import React from 'react';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import landingPageStyle from 'assets/jss/material-kit-react/views/landingPage.jsx';
import SignupForm from './SignupForm.jsx';
import { compose } from 'redux';
import { withTheme } from '@material-ui/core/styles';

class SignupStepper extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <div>
                <div />
                <div
                    className={classNames(classes.main) + ' signup-page'}
                    style={{ minHeight: '570px' }}
                >
                    <SignupForm />
                </div>
            </div>
        );
    }
}
const composedComponent = compose(
    withTheme(),
    withStyles(landingPageStyle)
);
export default composedComponent(SignupStepper);



// WEBPACK FOOTER //
// ./src/views/Signup/SignupStepper.jsx